/* Vivare: traduz textos fixos do tema que não passam pelo arquivo de idioma */
(function () {
  var T = {
    "Email address": "E-mail", "Email": "E-mail", "Your email": "Seu e-mail", "Enter your email": "Digite seu e-mail",
    "Password": "Senha", "password": "Senha", "confirm password": "Confirme a senha", "Text": "Texto",
    "Continue as Guest": "Continuar sem cadastro", "Guest login": "Comprar sem cadastro",
    "Guest login allows you to place orders without registration": "Você pode fazer pedidos sem criar uma conta",
    "Forgot your password?": "Esqueceu sua senha?", "Log in": "Entrar", "Registration": "Cadastro",
    "Restore Password": "Recuperar senha", "Address": "Endereço", "Update address": "Atualizar endereço",
    "Price:": "Preço:", "Total:": "Total:", "Body": "Mensagem",
    "Add your comment about the product of interest to you": "Deixe um comentário sobre o produto que você procura",
    "Show less": "Ver menos", "Show more": "Ver mais", "Share:": "Compartilhar:", "Share": "Compartilhar",
    "Product's name": "Nome do produto", "Product name": "Nome do produto", "Post name": "Nome do artigo",
    "Post link url": "Link do artigo", "100 products": "100 produtos", "Collection": "Categoria",
    "no image": "sem imagem", "View password page": "Ver página de senha", "Menu": "Menu",
    "This section doesn’t currently include any content. Add block to this section using the sidebar.": "Esta seção ainda não tem conteúdo."
  };
  var ATTRS = ["placeholder", "title", "aria-label", "alt"];
  function fixText(node) {
    var raw = node.nodeValue, t = raw && raw.trim();
    if (t && Object.prototype.hasOwnProperty.call(T, t)) node.nodeValue = raw.replace(t, T[t]);
  }
  function fixEl(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute && el.getAttribute(ATTRS[i]);
      if (v && Object.prototype.hasOwnProperty.call(T, v.trim())) el.setAttribute(ATTRS[i], T[v.trim()]);
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1) return;
    var tag = root.tagName;
    if (tag === "SCRIPT" || tag === "STYLE" || tag === "TEXTAREA") return;
    fixEl(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) {
        var p = n.parentNode && n.parentNode.tagName;
        if (p !== "SCRIPT" && p !== "STYLE" && p !== "TEXTAREA") fixText(n);
      } else fixEl(n);
    }
  }
  function start() {
    walk(document.body);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) walk(added[j]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();